import { IRestApiService, IRatePlanApiCall, RatePlanData, RatePlansResponse } from '../types';

class RatePlanApiCall implements IRatePlanApiCall {
  private restApiService: IRestApiService;

  constructor(restApiService: IRestApiService) {
    this.restApiService = restApiService;
  }

  getRatePlans(ownerId: string): Promise<RatePlansResponse> {
    const url = `rate-plan/${ownerId}`;
    return this.restApiService.get(url);
  }

  getRatePlan(ownerId: string, id: string): Promise<RatePlanData> {
    const url = `rate-plan/${ownerId}/${id}`;
    return this.restApiService.get(url);
  }

  getPublicRatePlan(ownerId: string, studioId?: string): Promise<RatePlansResponse> {
    let url = `rate-plan/${ownerId}/public`;
    if (studioId) {
      url += `?studioId=${studioId}`;
    }
    return this.restApiService.get(url);
  }

  addRatePlan(ownerId: string, data: RatePlanData): Promise<RatePlanData> {
    const url = `rate-plan/${ownerId}`;
    return this.restApiService.post(url, data);
  }

  updateRatePlan(ownerId: string, id: string, data: RatePlanData): Promise<RatePlanData> {
    const url = `rate-plan/${ownerId}/${id}`;
    return this.restApiService.put(url, data);
  }

  deleteRatePlan(ownerId: string, id: string): Promise<void> {
    const url = `rate-plan/${ownerId}/${id}`;
    return this.restApiService.delete(url);
  }

  startRatePlanTemplatesExport(ownerId: string): Promise<{ jobId: string; downloadUrl: string }> {
    const url = `rate-plan/${ownerId}/export-async`;
    return this.restApiService.post(url, {});
  }
}

export default RatePlanApiCall;
